(ns rothko.editor.newline.component)

(defn token
  [props]
  \newline)
